import { InteractiveContainer } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";
import ghostImage from "./assets/ghost.png";

export interface CXRobotAlertProps {
  title: string;
  text: ReactNode;
  buttonLabel: string;
  steps?: { current: number; total: number };
  className?: string;
  onClick: () => void;
}

export const CXRobotAlert: FC<CXRobotAlertProps> = ({
  title,
  text,
  buttonLabel,
  steps,
  className,
  onClick,
}) => (
  <div className={cx("bg-[#333333]", className)}>
    <div className="border-dark-800 flex items-center justify-between gap-2 border-0 border-b border-solid p-6 pb-0">
      <span className="font-secondary pb-2.5 text-lg font-semibold leading-[140%] text-white">
        {title}
      </span>
      <img
        src={ghostImage}
        alt=""
        className="pointer-events-none relative h-[60px] translate-x-[25px] translate-y-[0.5px]"
      />
    </div>
    <div className="py-2.5 px-6">
      <span className="text-sm font-normal leading-[150%] text-white">
        {text}
      </span>
    </div>
    <div className="mx-6 flex h-10 shrink-0 items-center justify-between px-2 pb-6">
      {steps ? (
        <span className="font-secondary text-xs text-[#DEDEE4]">
          {steps.current} / {steps.total}
        </span>
      ) : (
        <div />
      )}
      <InteractiveContainer
        className="font-secondary bg-[linear-gradient(149deg,#A9BDFF_68.46%,#F79FFF_93.9%)] bg-clip-text text-sm font-semibold uppercase leading-3 text-transparent"
        onClick={onClick}
      >
        {buttonLabel}
      </InteractiveContainer>
    </div>
  </div>
);
